import { createContext } from "react";

/**
 * Context for SrSelect component to manage submenu height and transitions.
 */
export const SUBMENU_TRANSITION_DURATION = "0.1s";

export type SubmenuHeightCtx = {
  openSubmenu: (panelHeight: number) => void;
  closeSubmenu: () => void;
};

export const SubmenuHeightContext = createContext<SubmenuHeightCtx | null>(null);

/**
 * Context to allow nested items (like in submenus) to trigger selection.
 */
export type SelectControlCtx = {
  handleItemClick: (value: unknown) => void;
};

export const SelectControlContext = createContext<SelectControlCtx | null>(null);
